import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Carousel } from 'react-bootstrap';

// Import images
import bedroomImage from '../assets/AboutUs/22.jpeg';
import womanImage from '../assets/AboutUs/10.jpeg'; // Update with the correct path

import img1 from '../assets/AboutUs/DSC_0600.JPG';
import img2 from '../assets/AboutUs/DSC_0367.JPG';
import img3 from '../assets/AboutUs/DSC_0683.JPG';
import img4 from '../assets/AboutUs/Ayurvedic-Spa-and-Wellness-Gallery4-1300x700-1-ezgif.com-webp-to-jpg-converter.jpg';
import img5 from '../assets/AboutUs/DSC_0461.JPG';
import img6 from '../assets/AboutUs/DSC_0326.JPG';
import img7 from '../assets/AboutUs/66286624.jpg';
import img8 from '../assets/AboutUs/DSC_0420.JPG';
import img9 from '../assets/AboutUs/WhatsApp Image 2025-02-14 at 00.15.14.jpeg';
import img10 from '../assets/AboutUs/DSC_0625.JPG';

// Image array for the carousel
const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

const AboutUs = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <section className="container my-5">
      <div className="row align-items-center">
        {/* Left Content */}
        <div className="col-md-6 order-md-1 order-2">
          <h1 className="display-4 fs-2 fs-md-1">Welcome to Cinnamon Mantra!</h1>
          <p className="lead fs-6 fs-md-5">
            Cinnamon Mantra Hotel & Ayurveda Spa is a tranquil sanctuary where luxury meets holistic wellness in the heart of Sri Lanka. Surrounded by lush landscapes, the hotel offers elegantly designed rooms, a serene Ayurveda spa with personalized treatments, and a gourmet restaurant serving organic, locally inspired cuisine. Guests can unwind with yoga and meditation sessions, explore scenic surroundings, and immerse themselves in Sri Lankan culture. Whether seeking relaxation, rejuvenation, or an authentic retreat, Cinnamon Mantra provides a perfect blend of comfort, tradition, and nature’s healing touch.
          </p>
          <div className="d-flex">
            <button
              type="button"
              className="btn me-3 btn-success btn-sm"
              onClick={() => (window.location.href = '/ayurveda-spa')}
            >
              Learn More
            </button>
            <button
              type="button"
              className="btn btn-outline-success btn-sm"
              onClick={() => (window.location.href = '/')}
            >
              SEE VIDEO
            </button>
          </div>
        </div>

        {/* Right Image Section */}
        <div className="col-md-6 order-md-2 order-1 text-center position-relative mb-4 mb-md-0">
          <img
            src={bedroomImage}
            alt="Bedroom"
            className="img-fluid rounded"
            style={{ borderRadius: '20px' }}
          />
          <div
            className="position-absolute d-none d-md-block"
            style={{
              bottom: '-20px',
              right: '-20px',
              width: '200px',
              height: '200px',
              borderRadius: '50%',
              overflow: 'hidden',
              border: '5px solid white',
            }}
          >
            <img
              src={womanImage}
              alt="Woman eating"
              className="img-fluid"
            />
          </div>
        </div>
      </div>

      {/* Image Slider Section */}
      <section className="mt-5">
        <h2 className="text-center fw-bold fs-1 fs-md-3">Photos</h2>
        <p className="text-center text-muted fs-6 fs-md-5">
          Discover the serenity of Cinnamon Mantra Villa & Ayurveda Spa in every photo
        </p>

        {/* Bootstrap Carousel (Thumbnails Removed) */}
        <Carousel activeIndex={index} onSelect={handleSelect} controls={true} interval={2000}>
          {images.map((img, i) => (
            <Carousel.Item key={i}>
              <img className="d-block w-100" src={img} alt={`Slide ${i + 1}`} />
            </Carousel.Item>
          ))}
        </Carousel>
      </section>
    </section>
  );
};

export default AboutUs;